import { put, takeLatest } from 'redux-saga/effects';
import * as actions from '../ducks/affiliate';
import { toastify } from '../ducks/toast';
import { request, finish } from './helpers';

function* getDashboard() {
  const res = yield* request('GET', '/aff/dashboard');
  if (res.status === 'success') yield put(actions.getDashboardSuccess(res.data));
  else if (res.status !== 'Unauthorized') yield put(toastify({ type: 'error', msg: res.m }));
}

function* getReferrals(action) {
  const res = yield* request('POST', '/aff/referrals', action.payload);
  if (res.status === 'success') yield put(actions.getReferralsSuccess(res.data));
  else if (res.status !== 'Unauthorized') yield put(toastify({ type: 'error', msg: res.m }));
}

function* getCommissions(action) {
  const res = yield* request('POST', '/aff/commissions', action.payload);
  if (res.status === 'success') yield put(actions.getCommissionsSuccess(res.data));
  else if (res.status !== 'Unauthorized') yield put(toastify({ type: 'error', msg: res.m }));
}

function* getWithdrawals() {
  const res = yield* request('GET', '/aff/withdrawals');
  if (res.status === 'success') yield put(actions.getWithdrawalsSuccess(res.data));
  else if (res.status !== 'Unauthorized') yield put(toastify({ type: 'error', msg: res.m }));
}

function* requestWithdraw(action) {
  const res = yield* request('POST', '/aff/withdraw', action.payload);
  const ok = yield* finish('requestWithdraw', res);
  if (ok) yield* getWithdrawals();
}

function* sendInvite(action) {
  const res = yield* request('POST', '/aff/invite', action.payload);
  yield* finish('sendInvite', res);
}

export default function* affiliateSaga() {
  yield takeLatest(actions.getDashboard.type, getDashboard);
  yield takeLatest(actions.getReferrals.type, getReferrals);
  yield takeLatest(actions.getCommissions.type, getCommissions);
  yield takeLatest(actions.getWithdrawals.type, getWithdrawals);
  yield takeLatest(actions.requestWithdraw.type, requestWithdraw);
  yield takeLatest(actions.sendInvite.type, sendInvite);
}
